import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: any) => ({
  requestContent: { padding: theme.spacing(0.5, 2.5, 0), marginLeft: theme.spacing(6), [theme.breakpoints.down('xs')]: { marginLeft: 0 } },
  titleRow: { display: 'flex', justifyContent: 'flex-end', marginBottom: theme.spacing(1.5) },
  actions: { padding: theme.spacing(0.5, 2.5, 1.5), gap: theme.spacing(1), justifyContent: 'flex-end' },
  pendingChip: { color: '#8a5a00', background: '#fff4d6' },
  acceptButton: { color: '#fff', backgroundColor: '#4caf50', '&:hover': { backgroundColor: '#388e3c' } },
  rejectButton: { color: '#fff', backgroundColor: '#cc092f', '&:hover': { backgroundColor: '#a80728' } },
}));
